var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2311 1.21875C5.45241 1.21875 1.56641 5.07494 1.56641 9.81639C1.56641 11.6967 2.17898 13.4394 3.21668 14.8572L2.13468 18.0495L5.46373 16.9917C6.83147 17.8891 8.47036 18.4131 10.2311 18.4131C15.0078 18.4131 18.8949 14.5566 18.8949 9.81639C18.8949 5.07494 15.0078 1.21875 10.2311 1.21875Z",
    fill: "url(#paint0_linear_3553_20810)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 9.74279C20 15.1225 15.6045 19.4847 10.1822 19.4847C8.46025 19.4847 6.84247 19.045 5.4361 18.2725L0 20L1.77198 14.7733C0.877779 13.305 0.363645 11.583 0.363645 9.74279C0.363645 4.36194 4.75918 0 10.1822 0C15.6044 0 20 4.36194 20 9.74279ZM10.1822 1.5517C5.62948 1.5517 1.92722 5.22561 1.92722 9.74286C1.92722 11.5343 2.51079 13.1945 3.49945 14.5454L2.4686 17.5867L5.64024 16.5789C6.94328 17.4339 8.50469 17.9331 10.1821 17.9331C14.733 17.9331 18.4363 14.2589 18.4363 9.74286C18.4364 5.22554 14.733 1.5517 10.1822 1.5517ZM15.14 11.9867C15.0792 11.887 14.9186 11.8273 14.6789 11.7078C14.4381 11.5886 13.2542 11.0103 13.0339 10.9311C12.8136 10.8517 12.6519 10.8117 12.4925 11.0503C12.3319 11.2892 11.8706 11.8273 11.7297 11.9867C11.5897 12.1464 11.4497 12.1658 11.2089 12.0464C10.9678 11.9273 10.1919 11.6742 9.27306 10.8617C8.55806 10.2279 8.07502 9.44671 7.93389 9.20784C7.79417 8.96925 7.91999 8.84007 8.03918 8.72088C8.14782 8.61336 8.28028 8.44198 8.40059 8.30309C8.52118 8.16308 8.56114 8.0631 8.64141 7.90367C8.72169 7.74424 8.68172 7.60535 8.62087 7.48588C8.56114 7.36669 8.07949 6.19142 7.87863 5.71285C7.67917 5.2356 7.47838 5.25342 7.33725 5.25342C7.19724 5.25342 6.93748 5.29506 6.93748 5.29506C6.93748 5.29506 6.455 5.35479 6.23479 5.59366C6.0145 5.83225 5.39285 6.41059 5.39285 7.58474C5.39285 8.75972 6.25449 9.89587 6.3748 10.0542C6.49531 10.2139 8.03925 12.7039 10.4862 13.66C12.9331 14.6159 12.9331 14.297 13.3745 14.2567C13.8151 14.2178 14.7982 13.6795 14.999 13.1217C15.1997 12.5639 15.1997 12.0856 15.14 11.9867Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3553_20810",
    x1: 10.2307,
    y1: 1.21875,
    x2: 10.2307,
    y2: 18.4131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AC14B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06853A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.4cbfbcfe87244c0f69bcabd2b8b13ecc.svg";
export { ForwardRef as ReactComponent };